module.exports = __webpack_public_path__ + "img/sample-voronoi-inverse.75845730.png";